/*
  UpdateSocialLinks
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connectModal as reduxModal, hide as hideModal } from 'redux-modal';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { submit } from 'redux-form';
import { updateCurrentUser } from 'store/features/auth/actions';
import { selectCurrentUserId } from 'store/features/auth/selectors';

import * as actionTypes from 'store/graphql/UpdateSocialLinks/action-types';
import Button from 'ui/common/button';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import { selectIsUpdatinSocialLinks } from 'store/graphql/UpdateSocialLinks/selectors';
import { compose, bindActionCreators } from 'redux';
import injectReducer from 'utils/injectReducer';
import UpdateSocialLinksReducer from 'store/graphql/UpdateSocialLinks/reducer';

import Form, { FORM_NAME } from './form';
export const MODAL_NAME = 'update-social-links';

const messages = defineMessages({
  title: {
    id: 'edit-user-basic-info.title',
    defaultMessage: 'Social Links',
  },
  save: {
    id: 'edit-user-basic-info.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'edit-user-basic-info.cancel',
    defaultMessage: 'Cancel',
  },
});

class UpdateSocialLinks extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onSubmit(values) {
    const {
      client,
      updateCurrentUser,
      currentUserId,
      hideModal,
      updateSocialLinksStart,
      updateSocialLinksSuccess,
      updateSocialLinksFailure,
    } = this.props;
    const { socialLinks } = values;
    updateSocialLinksStart();

    try {
      const response = await client.mutate({
        mutation: gql`
          mutation sociallinksUpdate($sociallinks: [socialLinks]!) {
            sociallinksUpdate(sociallinks: $sociallinks) {
              sociallinksUpdated
            }
          }
        `,
        variables: {
          sociallinks: socialLinks,
        },
      });

      const { errors } = response;

      if (errors) {
        updateSocialLinksFailure({ error: errors[0].messsage });
      } else {
        updateSocialLinksSuccess();
        updateCurrentUser.success({
          profile: {
            socialLinks,
            id: currentUserId,
          },
        });
        hideModal(MODAL_NAME);
      }
    } catch (error) {
      updateSocialLinksFailure(error);
    }
  }

  save() {
    this.props.submit(FORM_NAME);
  }

  render() {
    const { show, intl: { formatMessage }, handleHide, isUpdatingSocialLinks } = this.props;

    return (
      <Modal size="lg" isOpen={show}>
        <ModalHeader toggle={handleHide}>
          <h1 className="lead">{formatMessage(messages.title)}</h1>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={this.onSubmit} />
        </ModalBody>
        <ModalFooter>
          <Button
            iconPosition="suffix"
            isReady={false}
            loading={isUpdatingSocialLinks}
            onClick={this.save}
          >
            {formatMessage(messages.save)}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUpdatingSocialLinks: selectIsUpdatinSocialLinks(state),
    currentUserId: selectCurrentUserId(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateSocialLinksStart: () => dispatch({ type: actionTypes.UPDATE_SOCIAL_LINKS.START }),
    updateSocialLinksSuccess: () => dispatch({ type: actionTypes.UPDATE_SOCIAL_LINKS.SUCCESS }),
    updateSocialLinksFailure: error =>
      dispatch({ type: actionTypes.UPDATE_SOCIAL_LINKS.FAILURE, payload: { error } }),
    submit: bindActionCreators(submit, dispatch),
    hideModal: bindActionCreators(hideModal, dispatch),
    updateCurrentUser: {
      success: bindActionCreators(updateCurrentUser.success, dispatch),
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'UpdateSocialLinks',
  reducer: UpdateSocialLinksReducer,
});

export default compose(withReducer, withConnect)(
  reduxModal({
    name: MODAL_NAME,
  })(injectIntl(withApollo(UpdateSocialLinks)))
);
